import { BaseHeaderLinkDefinition } from '@msdk/definitions'
import React from 'react'

import { ConditionalLinkRenderer } from './ConditionalLinkRenderer'

interface Props {
  links: BaseHeaderLinkDefinition[]
  reload: (() => void) | (() => Promise<void>)
}

export function ViewHeaderLinks(props: Props) {
  return (
    <>
      {props.links.map((l, index) => (
        <ConditionalLinkRenderer key={index} link={l} reload={props.reload} />
      ))}
    </>
  )
}
